module.exports = __webpack_public_path__ + "assets/img/en@2x.dd5f8d03.png";